/**
 * Category Configuration
 * Defines sidebar categories with display order and icons.
 */

export interface CategoryDefinition {
  id: string;
  label: string;
  order: number;
}

export interface SystemRouteDefinition {
  path: string;
  label: string;
  icon: string;
  requiresPermission?: string;
}

export interface SystemCategoryDefinition {
  id: string;
  label: string;
  order: number;
  icon: string;
  routes: SystemRouteDefinition[];
}

export const CATEGORY_CONFIG: Record<string, CategoryDefinition> = {
  crm: {
    id: 'crm',
    label: 'CRM',
    order: 1,
  },
  fundraising: {
    id: 'fundraising',
    label: 'Fundraising',
    order: 2,
  },
  ir: {
    id: 'ir',
    label: 'Investor Relations',
    order: 3,
  },
  dealflow: {
    id: 'dealflow',
    label: 'Deal Flow',
    order: 4,
  },
  portfolio: {
    id: 'portfolio',
    label: 'Portfolio',
    order: 5,
  },
  sales: {
    id: 'sales',
    label: 'Sales',
    order: 6,
  },
  marketing: {
    id: 'marketing',
    label: 'Marketing',
    order: 7,
  },
};

/**
 * System Categories
 * Always-present sections that are not modules (e.g., Analytics, Data, System)
 */
export const SYSTEM_CATEGORIES: Record<string, SystemCategoryDefinition> = {
  system: {
    id: 'system',
    label: 'System',
    order: 97,
    icon: 'Settings',
    routes: [{ path: '/settings/apps', label: 'Installed Apps', icon: 'Blocks' }],
  },
  data: {
    id: 'data',
    label: 'Data',
    order: 98,
    icon: 'Database',
    routes: [{ path: '/data', label: 'Integrations', icon: 'Plug' }],
  },
  analytics: {
    id: 'analytics',
    label: 'Analytics',
    order: 99,
    icon: 'BarChart3',
    routes: [{ path: '/analytics', label: 'Dashboards', icon: 'FileBarChart' }],
  },
};
